/**
 * G-84 (OD-51): the Boxes tab's search. Pure, like `inventorySearch.ts`, so it
 * is testable without rendering. Matches the code in either spelling (a
 * florist types "17", "box 17" or reads "BX000017" off a label), the name,
 * and the kept-in zone.
 */
export interface BoxSearchable {
  code: string;
  barcodeText: string;
  name: string | null;
  keptInZone: { name: string } | null;
}

export function matchesBoxSearch(box: BoxSearchable, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const haystack = [box.code, box.barcodeText, box.name ?? "", box.keptInZone?.name ?? ""]
    .join(" ")
    .toLowerCase();
  if (haystack.includes(q)) return true;
  // "17" or "box 17" should find BOX-000017 without the zero padding.
  const digits = /^(?:bx|box[\s-]?)?(\d{1,6})$/i.exec(q);
  if (digits) {
    const n = Number(digits[1]);
    return Number(box.code.replace(/^BOX-/, "")) === n;
  }
  return false;
}
